import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PendingChangesGuard } from '../+shared/guards/pending-changes-guard.servie';
import { TechnicalDataComponent } from './technical-data/technical-data.component';
import { translateModule } from '../+shared/shared.translate.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../+shared/shared.module';
import {
  ButtonModule,
  CalendarModule,
  CheckboxModule,
  DropdownModule,
  FileUploadModule,
  InputNumberModule,
  InputSwitchModule,
  InputTextModule,
  RadioButtonModule,
  TooltipModule,
} from 'primeng';
import { CommonModule, JsonPipe } from '@angular/common';
import { DrrCcdDeviceUnitsComponent } from './technical-data/drr-ccd-device-units/drr-ccd-device-units.component';
import { DrrCcdDeviceComponent } from './technical-data/drr-ccd-device/drr-ccd-device.component';
import { CustomControlsModule } from '../+custom-controls/custom-controls.module';
import { CcdDrrPersonalDataFormComponent } from './personal-data-form/ccd-drr-personal-data-form.component';
import { GridApplicationSharedModule } from '../+grid-application-shared/grid-application-shared.module';
import { CcdDrrDocumentsFormComponent } from './documents-form/ccd-drr-documents-form.component';
import { CcdDrrCommissioningDataComponent } from './technical-data/commissioning-data/commissioning-data.component';
import { DetailsComponent } from './details/details.component';
import { OrderProcessComponent } from './order-process/order-process.component';
import { DrrCcdDataContextComponent } from './drr-ccd-data-context/drr-ccd-data-context.component';

@NgModule({
  declarations: [
    TechnicalDataComponent,
    DrrCcdDeviceComponent,
    DrrCcdDeviceUnitsComponent,
    CcdDrrPersonalDataFormComponent,
    CcdDrrDocumentsFormComponent,
    CcdDrrCommissioningDataComponent,
    DetailsComponent,
    OrderProcessComponent,
    DrrCcdDataContextComponent,
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      { path: 'technical-data', component: TechnicalDataComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'personal-data', component: CcdDrrPersonalDataFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'personal-data/:id', component: CcdDrrPersonalDataFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'documents', component: CcdDrrDocumentsFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'documents/:id', component: CcdDrrDocumentsFormComponent, canDeactivate: [PendingChangesGuard] },
      { path: 'details/:id', component: DetailsComponent, canDeactivate: [PendingChangesGuard] },
    ]),
    translateModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    CommonModule,
    InputNumberModule,
    RadioButtonModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    FileUploadModule,
    CustomControlsModule,
    GridApplicationSharedModule,
    TooltipModule,
    InputSwitchModule,
    CalendarModule,
  ],
  providers: [PendingChangesGuard, JsonPipe],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DrrCcdDevicesModule {}
